"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShiftTemplateMiddleware = void 0;
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const useShiftTemplateMiddleware = ({ initialData, loadDummyShift, reset, getValues, getShiftDefaultDetails, syncShiftSections, }) => {
    const workspace = (0, useWorkspace_1.useWorkspace)();
    const shiftTemplates = workspace?.shiftTemplates?.filter(util_1.isValue);
    const currentTemplate = shiftTemplates?.find((tmp) => tmp.id === initialData?.shiftTemplateId);
    const [templateName, setTemplateName] = react_1.default.useState((0, maybe_unwrap_1.unwrapMaybe)(currentTemplate?.name) ?? '');
    const applyShiftTemplate = react_1.default.useCallback((shiftTemplateId) => {
        const targetTemplate = workspace?.shiftTemplates?.find((template) => template?.id === shiftTemplateId);
        if ((0, util_1.isValue)(targetTemplate)) {
            const currentValues = getValues();
            const templatePeriod = {
                start: (0, util_1.isValue)(targetTemplate?.shift?.period?.start)
                    ? (0, moment_1.default)(targetTemplate?.shift?.period?.start)
                    : undefined,
                end: (0, util_1.isValue)(targetTemplate?.shift?.period?.end)
                    ? (0, moment_1.default)(targetTemplate?.shift?.period?.end)
                    : undefined,
            };
            if ((0, util_1.isValue)(templatePeriod.start)) {
                currentValues.period.start.set({
                    hours: templatePeriod.start.get('hours'),
                    minutes: templatePeriod.start.get('minutes'),
                });
            }
            if ((0, util_1.isValue)(templatePeriod.end)) {
                currentValues.period.end.set({
                    hours: templatePeriod.end.get('hours'),
                    minutes: templatePeriod.end.get('minutes'),
                });
            }
            const partialData = Object.assign({}, (0, maybe_unwrap_1.unwrapMaybe)(targetTemplate.shift), {
                userId: currentValues.user,
                period: currentValues.period,
            });
            const details = getShiftDefaultDetails(partialData);
            reset(details, {
                keepValues: false,
                keepDirtyValues: false,
                keepDefaultValues: false,
            });
            syncShiftSections(details);
            void loadDummyShift(getValues());
        }
    }, [reset, getValues]);
    return {
        templateName,
        setTemplateName,
        currentTemplate,
        applyShiftTemplate,
    };
};
exports.useShiftTemplateMiddleware = useShiftTemplateMiddleware;
